import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Stack,
  Avatar,
  Button,
  Select,
  MenuItem,
  TextField
} from "@mui/material";
import { useParams } from "react-router-dom";
import api from "../api/axios";
import ErrorDialog from "../components/ErrorDialog";

 const ProductReviews = ({ productId, productVendorId }) => {
   useParams();

 const [reviews, setReviews] = useState([]);
 // const [summary, setSummary] = useState(null);
 const [sort, setSort] = useState("recent");
const [selectedMedia, setSelectedMedia] = useState(null);
const [currentIndex, setCurrentIndex] = useState(0);
const [replyText, setReplyText] = useState({});
const [error, setError] = useState({ open: false, message: "" });

const [user, setUser] = useState(() =>
   JSON.parse(localStorage.getItem("user") || "null")
 );

 useEffect(() => {
   const handleStorageChange = () => {
     setUser(JSON.parse(localStorage.getItem("user") || "null"));
   };

   window.addEventListener("storage", handleStorageChange);

   return () => window.removeEventListener("storage", handleStorageChange);
 }, []);

 const isVendor = user?.role === "vendor";
 const isProductOwner = isVendor && productVendorId &&
   (user?._id === productVendorId || user?.vendorId === productVendorId);

useEffect(() => {
  if (!productId) return;

  loadReviews();
  // loadSummary();
}, [productId, sort]);

 const loadReviews = async () => {
  const res = await api.get(`/reviews/product/${productId}?sort=${sort}`);
  setReviews(res.data);
};


  return (
    <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
      <ErrorDialog
        open={error.open}
        onClose={() => setError({ open: false, message: "" })}
        message={error.message}
      />

      {/* SORT */}
      <Box sx={{ mb: 2 }}>
        <Select value={sort} onChange={(e) => setSort(e.target.value)} size="small">
          <MenuItem value="recent">Most Recent</MenuItem>
          <MenuItem value="helpful">Most Helpful</MenuItem>
          <MenuItem value="rating">Top Rated</MenuItem>
        </Select>
      </Box>

      {/* REVIEWS LIST */}
      {reviews.map((r) => {
  const name = r.userName || "Unknown User";
  const initial = name.charAt(0).toUpperCase();
const mediaItems = [
  ...(r.mediaUrls?.images || []).map((img) => ({
    type: "image",
    url: img
  })),
  ...(r.mediaUrls?.videos || []).map((vid) => ({
    type: "video",
    url: vid.url,
    thumbnail: vid.thumbnailUrl
  }))
];
  return (
    <Paper key={r._id} sx={{ p: 3, mb: 2, borderRadius: 2 }}>

      {/* USER */}
      <Stack direction="row" spacing={2} alignItems="center">
        <Avatar>{initial}</Avatar>
        <Typography fontWeight={600}>
          {name}
        </Typography>
      </Stack>

      {/* RATING */}
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
        <Typography>
          {calculateAvg(r.ratings).toFixed(1)} ⭐
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {new Date(r.createdAt).toLocaleDateString()}
        </Typography>
      </Stack>

      {/* TITLE */}
      <Typography fontWeight={700} sx={{ mt: 1 }}>
        {r.title}
      </Typography>

      {/* COMMENT */}
      <Typography sx={{ mt: 1 }}>
        {r.comment}
      </Typography>
{/* VENDOR REPLY */}
{r.vendorReply?.comment && (
  <Box
sx={{
  mt: 2,
  p: 2,
  bgcolor: "#f9fafb",
  borderRadius: 2,
  border: "1px solid #e0e0e0"
}}
  >
<Stack direction="row" spacing={1} alignItems="center">
  <Typography fontWeight={600} fontSize={14}>
    Vendor Response
  </Typography>
  <Typography
    sx={{
      fontSize: 11,
      bgcolor: "#1976d2",
      color: "#fff",
      px: 1,
      borderRadius: 1
    }}
  >
    Official
  </Typography>
</Stack>

    <Typography fontSize={14} sx={{ mt: 0.5 }}>
      {r.vendorReply.comment}
    </Typography>

    <Typography variant="caption" color="text.secondary">
      {new Date(r.vendorReply.updatedAt).toLocaleDateString()}
    </Typography>
  </Box>
)}

{isProductOwner && (
  <Box sx={{ mt: 2 }}>
<TextField
  fullWidth
  multiline
  minRows={2}
  value={replyText[r._id] || r.vendorReply?.comment || ""}
  onChange={(e) =>
    setReplyText({ ...replyText, [r._id]: e.target.value })
  }
  placeholder="Write a professional response..."
/>

    <Button
      size="small"
      sx={{ mt: 1 }}
      onClick={async () => {
        try {
          await api.post(`/reviews/${r._id}/reply`, {
            comment: replyText[r._id]
          });
          loadReviews(); // refresh to re-render Vendor Response section
        } catch (err) {
          console.error("Failed to post reply", err);
          const errorMessage = err.response?.data?.message || "You do not have permission to reply to this review.";
          setError({ open: true, message: errorMessage });
        }
      }}
    >
      {r.vendorReply ? "Update Reply" : "Post Reply"}
    </Button>
  </Box>
)}

{/* MEDIA */}
{/* MEDIA CAROUSEL */}
{mediaItems.length > 0 && (
  <Box>
    <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
      Customer Photos & Videos
    </Typography>

    <Stack direction="row" spacing={1}>
      {mediaItems.slice(0, 5).map((item, idx) => (
        <Box
          key={idx}
          onClick={() => {
            setSelectedMedia(mediaItems);
            setCurrentIndex(idx);
          }}
          sx={{
            position: "relative",
            width: 70,
            height: 70,
            borderRadius: 1,
            overflow: "hidden",
            cursor: "pointer",
            border: "1px solid #ddd",
            "&:hover": { borderColor: "#000" }
          }}
        >
          {/* IMAGE OR VIDEO THUMB */}
          <Box
            component="img"
            src={item.type === "image" ? item.url : item.thumbnail}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
          />

          {/* VIDEO PLAY ICON */}
          {item.type === "video" && (
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "rgba(0,0,0,0.6)",
                borderRadius: "50%",
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 14
              }}
            >
              ▶
            </Box>
          )}
        </Box>
      ))}
    </Stack>
  </Box>
)}
      {/* VERIFIED */}
      {r.isVerifiedPurchase && (
<Typography
  variant="caption"
  sx={{
    mt: 1,
    display: "inline-block",
    bgcolor: "#e6f4ea",
    color: "#1e7e34",
    px: 1,
    borderRadius: 1
  }}
>
  ✔ Verified Purchase
</Typography>
      )}

      {/* HELPFUL - Only show to product owner */}
{isProductOwner && (
<Button
  size="small"
  variant="outlined"
  sx={{ mt: 1, textTransform: "none" }}
>
  👍 Helpful ({r.helpfulCount || 0})
</Button>
)}
    </Paper>
  );
})}
{selectedMedia && (
  <Box
    onClick={() => setSelectedMedia(null)}
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      bgcolor: "rgba(0,0,0,0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    }}
  >
    {/* LEFT */}
    <Button
      onClick={(e) => {
        e.stopPropagation();
        setCurrentIndex((prev) =>
          prev === 0 ? selectedMedia.length - 1 : prev - 1
        );
      }}
      sx={{ position: "absolute", left: 20, color: "#fff", fontSize: 30 }}
    >
      ◀
    </Button>

    {/* 🔥 CONTENT SWITCH */}
    {selectedMedia[currentIndex]?.type === "image" ? (
      <Box
        component="img"
        src={selectedMedia[currentIndex].url}
        onClick={(e) => e.stopPropagation()}
        sx={{
          maxWidth: "90%",
          maxHeight: "80%",
          borderRadius: 2
        }}
      />
    ) : (
      <video
        src={selectedMedia[currentIndex].url}
        controls
        autoPlay
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: "90%",
          maxHeight: "80%",
          borderRadius: 8
        }}
      />
    )}

    {/* RIGHT */}
    <Button
      onClick={(e) => {
        e.stopPropagation();
        setCurrentIndex((prev) =>
          prev === selectedMedia.length - 1 ? 0 : prev + 1
        );
      }}
      sx={{ position: "absolute", right: 20, color: "#fff", fontSize: 30 }}
    >
      ▶
    </Button>
  </Box>
)}

    </Box>
  );
}

export default ProductReviews;


/* ⭐ Calculate Avg Rating */
const calculateAvg = (ratings) => {
  if (!ratings) return 0;

  const values = [
    ratings.productQuality,
    ratings.valueForMoney,
    ratings.deliveryExperience,
    ratings.sellerService,
    ratings.agentExperience,
  ].filter(Boolean);

  return values.length
    ? values.reduce((a, b) => a + b, 0) / values.length
    : 0;
};
